// Copyright (c) StrangeBee 2023

import { useLocalMessage } from '@Helpers/locale';
import React, { ReactElement } from 'react';
import { THButton } from '../THButton/THButton';

import './THEditableButtons.scss';

interface THEditableButtonsProps {
    onCancel?: () => void;
    onSubmit?: () => void;
}

export const THEditableButtons = ({ onCancel, onSubmit }: THEditableButtonsProps): ReactElement => {
    const i = useLocalMessage();

    return (
        <div className="th-editable-buttons">
            <THButton type="link" color="red" onClick={(): void => onCancel?.()}>
                {i('general.cancel')}
            </THButton>
            <THButton type="link" htmlType="submit" onClick={(): void => onSubmit?.()}>
                {i('general.save')}
            </THButton>
        </div>
    );
};
